<template>
  <!-- id="map-template" -->
  <div class="zj-homeview-root select-none">
    <div id="transform_box"></div>

    <MapView
      ref="map"
      @mapLoaded="mapLoaded"
      @mouseClickObject="objectClick"
      @entitieMouseLeave="entitieMouseLeave"
      @entitieMouseEnter="entitieMouseEnter"
    ></MapView>

    <!-- 顶部tab -->
    <!-- <div class="btn-audio" style="height:0px;overflow:hidden;">
          <audio class="mp3Btn" :src="audiosrc" id="source" loop autoplay="true" controls="controls">
          </audio>
      </div> -->
    <ul class="tabBox">
      <li
        v-for="(item, index) in tabList"
        :class="{ activeLi: index == activeInd }"
        v-bind:key="index"
        @click="changeTab(index)"
      >
        {{ item.name }}
      </li>
    </ul>
    <ScreenTab
      :filtes="filtes"
      ref="screenTab"
      @select="screenPoint"
      v-if="!isBottomHide"
    ></ScreenTab>
    <MapControl
      @control="mapControl"
      :gridTypes="gridTypeList"
      :regions="region"
      v-if="!isBottomHide"
    ></MapControl>
    <div class="left-side-flow" v-if="activeInd == '0' && !isLeftSideHide">
      <HomeViewFlow></HomeViewFlow>
    </div>
    <el-dialog
      class="emergencyoperations-dialog normal"
      custom-class="bg3"
      top="6vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isShowPop"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :modal="false"
      v-if="isShowPop"
    >
      <NewTask
        v-if="isShowPop"
        @handlerclose="isShowPop = false"
        @newtaskcreated="newtaskcreated"
        v-bind:tableData="tableData"
        :messageDatail="messageDatail"
        @closeTask="closeMsg"
      />
    </el-dialog>
    <div
      class="right-side_box2"
      :class="{ positionR1: showzhi, positionR2: !showzhi }"
      v-if="activeInd == '0' && !isRightSideHide"
    >
      <HomeViewMsgTask
        v-if="isShowMsg"
        @addTask="showaddTask"
        @lookDetail="showTaskDetail"
        @lookMsgDetail="lookMsgDetail"
        @showEarlymsg="showEarlymsg"
      ></HomeViewMsgTask>

      <MsgInfo
        v-if="isShowMsgdP"
        v-bind:msgId="msgId"
        v-bind:isShowMsgDetail="isShowMsgDetail"
        @closeMsgDetail="closeMsgDetail"
        @handleTask="handleTask"
      ></MsgInfo>
      <MsgWarningInfo
        v-if="isShowMsgWarning"
        v-bind:msgId="msgId"
        v-bind:alarmId="alarmId"
        v-bind:isShowMsgDetail="isShowMsgDetail"
        @closeMsgWarningDetail="closeMsgWarningDetail"
        @handleTask="handleTask"
      ></MsgWarningInfo>
      <MsgHelpInfo
        v-if="isShowMsgHelp"
        v-bind:msgId="msgId"
        v-bind:alarmId="alarmId"
        v-bind:isShowMsgDetail="isShowMsgDetail"
        @closeMsgHelpDetail="closeMsgHelpDetail"
        @handleTask="handleTask"
      ></MsgHelpInfo>
      <!-- <HomeViewTaskPop v-if="isShowPop" @closePOP="closePOP"></HomeViewTaskPop> -->
      <taskDetails
        v-if="isTaskD"
        @closeTaskDetail="closeTaskDetail"
        v-bind:ExecutTaskId="ExecutTaskId"
        v-bind:isLookDetails="isLookDetails"
      ></taskDetails>
      <!-- 设备故障弹窗 -->
      <HomeViewEquipment
        v-if="isShowEquip"
        @closeEquipMent="closeEquipMent"
        @handleREN="handleREN"
        @handleTask="handleTask"
        @lookMsgDetail="lookMsgDetail"
      ></HomeViewEquipment>
      <HomeViewSOSForm
        v-if="isShowSoSForm"
        @closeFrom="closeFrom"
      ></HomeViewSOSForm>
    </div>

    <div class="left-side-flow" v-if="activeInd == '1' && !isLeftSideHide">
      <HomeViewPeople @connect="getConnectInfo"></HomeViewPeople>
    </div>
    <div
      class="right-side_box"
      :class="{ positionR1: showzhi, positionR2: !showzhi }"
      v-if="activeInd == '1' && !isRightSideHide"
    >
      <LinkGroup></LinkGroup>
      <!-- 对讲接通 -->
      <HomeViewSOS v-if="isShowSoS" @closeSOS="closeSOS"></HomeViewSOS>
    </div>
    <div class="left-side-flow" v-if="activeInd == '2' && !isLeftSideHide">
      <ScienceLeft></ScienceLeft>
    </div>
    <div
      class="right-side_box"
      :class="{ positionR1: showzhi, positionR2: !showzhi }"
      v-if="activeInd == '2' && !isRightSideHide"
    >
      <ScienceRight></ScienceRight>
    </div>
    <div class="left-side-flow" v-if="activeInd == '3' && !isLeftSideHide">
      <HomeViewEquipmentLeft></HomeViewEquipmentLeft>
    </div>
    <div
      class="right-side_box"
      :class="{ positionR1: showzhi, positionR2: !showzhi }"
      v-if="activeInd == '3' && !isRightSideHide"
    >
      <HomeViewEquipmentRight></HomeViewEquipmentRight>
    </div>
    <div class="left-side-flow" v-if="activeInd == '4' && !isLeftSideHide">
      <GeologyLeft></GeologyLeft>
    </div>
    <div
      class="right-side_box2"
      :class="{ positionR1: showzhi, positionR2: !showzhi }"
      v-if="activeInd == '4' && !isRightSideHide"
    >
      <GeologyRight></GeologyRight>
    </div>
    <div
      class="right-side_box2 positionR2"
      v-if="isShowGrid && isRightSideHide"
    >
      <Grid :id="gridId" @closegrid="closegrid" :gridList="gridList"></Grid>
    </div>
    <div class="left-side-flow2" v-if="activeInd == '5' && !isLeftSideHide">
      <projectLeft></projectLeft>
    </div>
    <div
      class="right-side_box"
      :class="{ positionR1: showzhi, positionR2: !showzhi }"
      v-if="activeInd == '5' && !isRightSideHide"
    >
      <projectRight></projectRight>
    </div>
    <!-- 值班人 -->
    <div class="zhibanBox" v-if="showzhi && !isRightSideHide">
      <div class="titlezhi">
        <span>值班信息</span>
        <img
          class="closebtnzhib"
          src="../../../../../assets/close.png"
          alt=""
          @click="changeShowDuty"
        />
      </div>
      <div class="zhibanInfo">
        <div class="zhibanOne" v-for="(value, key) in dutyList" :key="key">
          <div class="oneTitle">{{ key }}</div>
          <div class="zhibanOneInfo">
            <template v-for="(item, index) in value">
              <div class="info">
                <span class="left">{{ item.role }}</span>
                <span class="right">{{ item.name }}</span>
              </div>
              <div class="info">
                <span class="left">电话：</span>
                <span class="right">{{ item.phone }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      class="miniZhiban"
      v-if="!showzhi && !isRightSideHide"
      @click="changeShowDuty"
    ></div>

    <div class="left-side" v-show="false">
      <!-- !isLeftSideHide -->
      <div class="left-side-1">
        <div class="content-wrapper">
          <HomeViewRealtimeData></HomeViewRealtimeData>
        </div>
      </div>
      <div class="left-side-2">
        <div class="content-wrapper">
          <HomeViewDeviceList></HomeViewDeviceList>
        </div>
      </div>
      <div class="left-side-3">
        <div class="content-wrapper">
          <HomeViewCarparkList></HomeViewCarparkList>
        </div>
      </div>
    </div>
    <div class="right-side" v-if="false">
      <!-- v-show="!isRightSideHide" -->
      <div class="right-side-wrapper">
        <div class="right-side-1">
          <div class="content-wrapper">
            <HomeViewMessageCenter></HomeViewMessageCenter>
          </div>
        </div>
        <div class="right-side-2">
          <div class="content-wrapper">
            <HomeViewTaskCenter></HomeViewTaskCenter>
          </div>
        </div>
        <div class="right-side-3">
          <div class="content-wrapper">
            <HomeViewVideoCenter></HomeViewVideoCenter>
          </div>
        </div>
        <div class="right-side-4">
          <div class="content-wrapper">
            <HomeViewFastTrackEntrance></HomeViewFastTrackEntrance>
          </div>
        </div>
      </div>
    </div>
    <div
      class="left-hide-btn"
      :class="{ working: isLeftSideHide }"
      @click="handleLeftHide"
    ></div>
    <div
      class="right-hide-btn"
      :class="{ working: isRightSideHide }"
      @click="handleRightHide"
    ></div>
    <div
      class="bottom-hide-btn"
      :class="{ working: isBottomHide }"
      @click="handleBottomHide"
    ></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import websoket from "../../../../../websoket/websoket";
import HomeViewRealtimeData from "./components/HomeViewRealtimeData";
import HomeViewDeviceList from "./components/HomeViewDeviceList";
import HomeViewCarparkList from "./components/HomeViewCarparkList";
import HomeViewMessageCenter from "./components/HomeViewMessageCenter";
import HomeViewTaskCenter from "./components/HomeViewTaskCenter";
import HomeViewVideoCenter from "./components/HomeViewVideoCenter";
import HomeViewFastTrackEntrance from "./components/HomeViewFastTrackEntrance";
// import NewTask from "./components/NewTask";
import NewTask from "./components/Component-NewTask-Home";
// import NewTask from '../../../../emergency/src/views/src/EmergencyOperations/Components/Component-NewTask-Home'

// 流量左侧组件
import HomeViewFlow from "./components/HomeViewFlow";
// 消息和任务
import HomeViewMsgTask from "./components/HomeViewMsgTask";
import HomeViewTaskPop from "./components/HomeViewTaskPop";
// 消息详情
//import MsgDetail from "./components/MsgDetail";
import MsgInfo from "./components/MsgInfo";

//预警类型的消息详情
import MsgWarningInfo from "./components/MsgWarningInfo";
//求助类型的消息详情
import MsgHelpInfo from "./components/MsgHelpInfo";

// 任务详情
import taskDetails from "./components/taskDetails";
// 筛选条件tab
import ScreenTab from "./components/screenTab";
// 地图控件
import MapControl from "./components/MapControl";
// 地图组件
import MapView from "./components/cesiumMap";

// 常量
import { criteria, icons, peoples, shebeiIcons } from "./config/constant";
// 网格
import Grid from "./components/grid";
// 设备故障
import HomeViewEquipment from "./components/HomeViewEquipment";
import HomeViewEquipmentLeft from "./components/HomeViewEquipmentLeft";
import HomeViewEquipmentRight from "./components/HomeViewEquipmentRight";
import HomeViewSOS from "./components/HomeViewSOS";
import HomeViewSOSForm from "./components/HomeViewSOSForm";
//人员
import HomeViewPeople from "./components/HomeViewPeople";
import LinkGroup from "./components/LinkGroup";
import UserTabControl from "./components/UserTabControl";
// 环境监测
import ScienceLeft from "./components/ScienceLeft";
import ScienceRight from "./components/ScienceRight";
// 地质
import GeologyLeft from "./components/GeologyLeft";
import GeologyRight from "./components/GeologyRight";
// 项目
import projectLeft from "./components/projectLeft";
import projectRight from "./components/projectRight";

// 请求

import {
  queryBounds,
  queryWeather,
  queryGeology,
  queryEquipment,
  nowDensity,
  nowToilet,
  nowPassenger,
  nowDevice,
  nowParking,
  rateOfFlow,
  queryGrid,
  queryGridType,
  queryGridFindPage,
  getEnvPoint,
} from "../../apis/src/Query";
import base64 from "../../../../../utils/src/base64";

import centerOfMass from "@turf/center-of-mass";
const heleprs = require("@turf/helpers");
var coordtransform = require("coordtransform");

import { getMsgPOP, lookduty } from "../../../../../request/msgApi";
import dataServerApi from "../../../../../request/dataServerApi";
import { resAppLocation } from "../../../../../request/analysisApi";
import MyApis from "../../apis"; 

import {
  htmlToBase64OfImg,
  defaultPoiIcon,
  environmentPoiIcon,
  geologyPoiIcon,
} from "./methods/methods";
import qAudio from "../../../../../assets/qAudio.mp3";
import rAudio from "../../../../../assets/rAudio.mp3";
export default {
  name: "HomeView",
  controller: "UI",
  action: "HomeView",
  components: {
    MapView,
    HomeViewRealtimeData,
    HomeViewDeviceList,
    HomeViewCarparkList,
    HomeViewMessageCenter,
    HomeViewTaskCenter,
    HomeViewVideoCenter,
    HomeViewFastTrackEntrance,
    HomeViewFlow,
    HomeViewMsgTask,
    HomeViewTaskPop,
    ScreenTab,
    MapControl,
    HomeViewEquipment,
    HomeViewSOS,
    HomeViewSOSForm,
    HomeViewPeople,
    LinkGroup,
    UserTabControl,
    HomeViewEquipmentLeft,
    HomeViewEquipmentRight,
    ScienceLeft,
    ScienceRight,
    GeologyLeft,
    GeologyRight,
    Grid,
    NewTask,
    projectRight,
    projectLeft,
    MsgInfo,
    taskDetails,
    MsgWarningInfo,
    MsgHelpInfo,
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      isLeftSideHide: false,
      isRightSideHide: false,
      isBottomHide: false,
      typeFather: "",
      tabList: [
        {
          name: "流量",
          type: "liuliang",
        },
        {
          name: "通讯",
          type: "tongxun",
        },
        {
          name: "环境",
          type: "huanjing",
        },
        {
          name: "设备",
          type: "shebei",
        },
        {
          name: "地质",
          type: "dizhi",
        },
        {
          name: "图纸",
          type: "tuzhi",
        },
      ],
      filtes: [],
      wesoketReconnect: false, //避免重复连接
      activeInd: 0,
      isShowPop: false,
      isShowEquip: false,
      isShowSoS: false,
      isShowSoSForm: false,
      isShowMsg: true,
      isShowGrid: false,
      ws: "",
      earlyMsgData: "",
      ExecutId: "newtaskfortaskcenter",
      isLookDetails: false,
      tableData: [],
      gridList: [],
      gridElementId: "",
      mapInitData: {
        longitude: 88.12878002341338,
        latitude: 43.76162150014898,
        height: 12800,
        heading: 0,
        pitch: -30,
      },
      // 区域列表
      region: null,
      regionIndex: 0,
      showBound: false,
      audiosrc: "",
      autoplay: true,
      showAudio: false,
      // 点位
      pointCollects: {},
      msgId: "",
      isShowMsgDetail: false,
      isShowMsgdP: false,
      isTaskD: false,
      boundEntities: {},
      // 鼠标进入实例
      pickedFeature: null,
      dutyList: [],
      showzhi: true,
      gridId: "",
      gridTypeList: [],
      tongxun: [],
      messageDatail: {},
      isShowMsgWarning: false,
      isShowMsgHelp: false,
      alarmId: "",
      messageInfo: {},
      tongxunTimer:null
    };
  },
  methods: {
    ...mapActions(["submittEarlyMsg"]),
    getConnectInfo() {
      //data
      let that = this;
      // resAppLocation({}).then(res=>{
      //   console.log("resAppLocation+++++++++++")
      //   console.log(res)
      //   that.tongxun = res.data
      // })
      // const collect = new Cesium.EntityCollection();
      // for(let i=0;i<30;i++){
      //   data.push(
      //   {
      //     userName:"语音对讲9",
      //   id:"xiajiang",
      //   dictAppType:"综合执法处",
      //   longitude:88.125312,
      //   latitude:43.919021
      // })
      // }

      // that.tongxun = data;
      this.screenPoint({ index: 0 - 1, type: this.tabList[1].type });
    },
    changeShowDuty() {
      this.showzhi = !this.showzhi;
    },
    showEarlymsg(data) {
      let _this = this;
      this.isShowEquip = true;
      _this.earlyMsgData = data;
      //  _this.playAudio();
      setTimeout(function () {
        _this.isShowEquip = false;
        // _this.closeAudio();
      }, 3000);
    },
    createRegion() {
      const that = this;
      const { regionIndex, boundEntities } = this;
      this.removeRegion();
      const currentRegion = this.region[regionIndex];
      if (boundEntities.hasOwnProperty(regionIndex)) {
        boundEntities[regionIndex].show = true;
      } else {
        const collect = new Cesium.EntityCollection();
        boundEntities[regionIndex] = collect;
        const { bounds } = currentRegion;
        const { renderPolygon } = this.$refs.map;

        bounds.forEach((item, index) => {
          const bound = [];
          item.bound.forEach((item) => {
            const [lon, lat] = item;
            bound.push(lon, lat);
          });
          const id = `bound|${this.regionIndex}|${index}`;

          const polygon = renderPolygon({
            id,
            pointArray: bound,
            options: {
              lineColor: "#00ddff",
              outlineColor: "#00000000",
            },
          });
          collect.add(polygon);
        });
      }
    },
    removeRegion() {
      const { regionIndex, boundEntities } = this;
      for (const key in boundEntities) {
        if (Object.hasOwnProperty.call(boundEntities, key)) {
          const collect = boundEntities[key];
          collect.show = false;
        }
      }
    },
    playAudio() {
      let myAudio = document.getElementById("source");
      this.audiosrc = rAudio;
      myAudio.play();
    },
    closeAudio() {
      let myAudio = document.getElementById("source");
      this.audiosrc = "";
      myAudio.pause();
    },
    entitieMouseEnter({ pickedFeature, worldPosition, x, y }) {
      console.log(pickedFeature)
      console.log(worldPosition)
      console.log(x)
      console.log(y)
      const that = this;
      const {
        id: { id },
      } = pickedFeature;
      const [objType, ...keys] = id.split("|");
      const [type, screen, code] = keys;
      this.pickedFeature = pickedFeature;
      const methods = {
        poi() {
          if (type === "shebei") {
            pickedFeature.id.label.show = true;
          }
        },
        polygon() {
          if (type === "grid") {
            that.$refs.map.highlightPolygonEntity(id);
            // pickedFeature.id.label.show = true;
          }
        },
        polyline() {},
      };
      methods[objType]();
    },
    entitieMouseLeave() {
      const that = this;
      const {
        id: { id },
      } = that.pickedFeature;
      const [objType, ...keys] = id.split("|");
      const [type, screen, code] = keys;
      const methods = {
        poi() {
          if (type === "shebei") {
            that.pickedFeature.id.label.show = false;
            that.pickedFeature = null;
          }
        },
        polygon() {
          if (type === "grid") {
            that.$refs.map.removeHighlightPolygonEntity(id);
            that.pickedFeature = null;
            // pickedFeature.id.label.show = true;
          }
        },
        polyline() {},
      };
      methods[objType]();
      // if (this.pickedFeature) {
      //   this.pickedFeature.id.label.show = false;
      //   this.pickedFeature = null;
      // }
    },
    entitieMouseOver() {
      // alert(1);
    },
    objectClick({ id, location, x, y }) {
      const { poiClick, polygonClick, polylineClick } = this;
      const [objType, ...keys] = id.split("|");
      const [type, screen, code] = keys;
      const key = keys.join("|");
      const methods = {
        poi() {
          poiClick({ key, code, screen, x, y });
        },
        polygon() {
          polygonClick({ key, type, screen });
        },
        polyline() {
          polylineClick({ key, code, screen });
        },
      };
      methods[objType]();
    },
    poiClick({ key, code, screen, x, y }) {
      console.log({ key, code, screen, x, y }, "poi");
    },
    polygonClick({ key, type, screen }) {
      console.log({ key, type, screen }, "polygon");
    },
    polylineClick({ key, code, screen }) {
      console.log({ key, code, screen }, "polylineClick");
    },
    changeTab(index) {
      this.activeInd = index;
      this.filtes = criteria[this.tabList[index].type];
      this.typeFather = this.tabList[index].type;
      console.log("+++++++++++++++++++++++++++++++++++++++++");
      console.log(this.filtes);
      console.log(this.typeFather);
      if (this.filtes.length > 0) {
        this.$refs.screenTab.select({ index: 0, type: this.filtes[0].type });
      } else {
        this.screenPoint({ index: 0 - index, type: this.tabList[index].type });
      }
    },
    defaultIconOfPoint({ id, lon, lat, icon, firstText, secondText, collect, thirdText }) {
      const { renderPoint } = this.$refs.map;
      defaultPoiIcon({
        first: firstText,
        second: secondText,
        third: thirdText,
        bgi: icons.bubble1,
        icon,
      }).then(({ img }) => {
        const point = renderPoint({ id, lon, lat, name: "", img });
        collect.add(point);
      });
    },
    hidePoint(e) {
      const { pointCollects } = this;
      console.log(e, { ...pointCollects }, "hidepoint");
      for (const key in pointCollects) {
        if (pointCollects.hasOwnProperty.call(pointCollects, key)) {
          const collect = pointCollects[key];
          collect.show = false;
        }
      }
    },
    screenPoint(item) {
      const { typeFather, defaultIconOfPoint, hidePoint } = this;
      const that = this;
      const { renderPoint } = this.$refs.map;
      const { index, type } = item;
      let tongxunTimer = this.tongxunTimer;
      hidePoint(item);
      // TODO 可拆分到另一文件
      const methods = {
        liuliang: {
          getData({ collect, type }) {
            rateOfFlow({
              success(res) {
                res.forEach((element, index) => {
                  const {
                    poi,
                    wgsLatitude,
                    wgsLongitude,
                    gpsLatitude,
                    gpsLongitude,
                    name,
                    deviceName,
                    deviceCode,
                    code,
                    id,
                    key,
                    secondText,
                    screenType,
                  } = element;
                  if (poi) {
                    const [lon, lat] = poi
                      .split(",")
                      .map((item) => Number(item));
                    defaultIconOfPoint({
                      lon: Number(wgsLongitude) || lon,
                      lat: Number(wgsLatitude) || lat,
                      id: key,
                      firstText: name || deviceName,
                      secondText,
                      collect,
                    });
                  }
                });
              },
              type,
            });
          },
          default() {
            this.keliujiance();
            this.midujiance();
            this.tingchechang();
            this.zhinengcesuo();
          },
          keliujiance() {
            if (!that.pointCollects.hasOwnProperty("keliujiance")) {
              console.log("keliujiance", true);
              const collect = new Cesium.EntityCollection();
              this.getData({ collect, type: "keliujiance" });
              that.pointCollects.keliujiance = collect;
            } else {
              console.log("keliujiance", false);
              that.pointCollects.keliujiance.show = true;
            }
          },
          midujiance() {
            if (!that.pointCollects.hasOwnProperty("midujiance")) {
              console.log("midujiance", true);
              const collect = new Cesium.EntityCollection();
              this.getData({ collect, type: "midujiance" });
              that.pointCollects.midujiance = collect;
            } else {
              console.log("midujiance", false);
              that.pointCollects.midujiance.show = true;
            }
          },
          tingchechang() {
            if (!that.pointCollects.hasOwnProperty("tingchechang")) {
              const collect = new Cesium.EntityCollection();
              this.getData({ collect, type: "tingchechang" });
              that.pointCollects.tingchechang = collect;
            } else {
              that.pointCollects.tingchechang.show = true;
            }
          },
          zhinengcesuo() {
            if (!that.pointCollects.hasOwnProperty("zhinengcesuo")) {
              const collect = new Cesium.EntityCollection();
              this.getData({ collect, type: "zhinengcesuo" });
              that.pointCollects.zhinengcesuo = collect;
            } else {
              that.pointCollects.zhinengcesuo.show = true;
            }
          },
        },
        tongxun: {
          getXunjianApp(){
            resAppLocation({}).then(res=>{
              console.log("resAppLocation+++++++++++")
              console.log(res)
              let data = res.data;
              data.map(item=>{
                let arr = item.location.split(",");
                item.latitude = arr[1];
                item.longitude = arr[0];
                item.id = item.usercode;
                item.dictAppType = item.organizationName;
                // item.userName = item.userName + item.phone;
              })
              that.tongxun = res.data;
              console.log("that.pointCollects")
              console.log(that.pointCollects)
              if(that.tongxun.length==0){
                if (!that.pointCollects.hasOwnProperty("tongxun")) {
                  console.log(1)
                  return
                }else{
                  console.log(2)
                  that.pointCollects.tongxun.show = false;
                  return
                }
              }
              if (!that.pointCollects.hasOwnProperty("tongxun")) {
              const collect = new Cesium.EntityCollection();
              let randomStr = that.randomString(11);
              console.log("that.tongxun")
              console.log(that.tongxun)

              that.tongxun.forEach((item) => {
                // const { longitude, latitude, name, id, department } = item;
                const { longitude, latitude, userName, id, dictAppType, phone } = item;
                const key = `tongxun|${randomStr}|${id}`;
                defaultIconOfPoint({
                  lon: Number(longitude),
                  lat: Number(latitude),
                  id: key,
                  firstText: dictAppType,
                  secondText: phone,
                  thirdText: userName,
                  collect,
                });
              });
              that.pointCollects.tongxun = collect;
            } else {
              let randomStr = that.randomString(11);
              let collect = that.pointCollects.tongxun;
              collect.removeAll()
              that.tongxun.forEach((item) => {
                // const { longitude, latitude, name, id, department } = item;
                const { longitude, latitude, userName, id, dictAppType, phone } = item;
                const key = `tongxun|${randomStr}|${id}`;
                defaultIconOfPoint({
                  lon: Number(longitude),
                  lat: Number(latitude),
                  id: key,
                  firstText: dictAppType,
                  secondText: phone,
                  thirdText: userName,
                  collect,
                });
              });
              // that.pointCollects.tongxun.show = true;
            }
            })
          },
          default() {
            delete that.pointCollects.tongxun;
            this.getXunjianApp();
            let th = this;
            that.tongxunTimer =  setInterval(function(){
              th.getXunjianApp()
            },30000);
            // const collect = new Cesium.EntityCollection();
           
            // if (!that.pointCollects.hasOwnProperty("tongxun")) {
            //   const collect = new Cesium.EntityCollection();
            //   let randomStr = that.randomString(11);
            //   // console.log("that.tongxun")
            //   // console.log(that.tongxun)
            //   that.tongxun.forEach((item) => {
            //     // const { longitude, latitude, name, id, department } = item;
            //     const { longitude, latitude, userName, id, dictAppType } = item;
            //     const key = `tongxun|${randomStr}|${id}`;
            //     defaultIconOfPoint({
            //       lon: Number(longitude),
            //       lat: Number(latitude),
            //       id: key,
            //       firstText: dictAppType,
            //       secondText: userName,
            //       collect,
            //     });
            //   });
            //   that.pointCollects.tongxun = collect;
            // } else {
            //   that.pointCollects.tongxun.show = true;
            // }
          },
        },
        huanjing: {
          default({ success }) {
            getEnvPoint({
              success(res) {
                const arr = res.map((item, index) => {
                  item.key = `huanjing|${type}|${index}`;
                  return item;
                });
                success(arr);
              },
            });
          },
          wendu() {
            if (!that.pointCollects.hasOwnProperty("wendu")) {
              const collect = new Cesium.EntityCollection();
              this.default({
                success(res) {
                  res.forEach((item) => {
                    const { temperature, key, latitude, longitude, siteName } =
                      item;
                    temperature &&
                      defaultIconOfPoint({
                        collect,
                        lon: Number(longitude),
                        lat: Number(latitude),
                        id: key,
                        firstText: siteName,
                        secondText: `温度: ${temperature}℃`,
                      });
                  });
                },
              });
              that.pointCollects.wendu = collect;
            } else {
              that.pointCollects.wendu.show = true;
            }
          },
          shidu() {
            if (!that.pointCollects.hasOwnProperty("shidu")) {
              const collect = new Cesium.EntityCollection();
              this.default({
                success(res) {
                  res.forEach((item) => {
                    const {
                      atmosphericHumidity,
                      key,
                      latitude,
                      longitude,
                      siteName,
                    } = item;
                    atmosphericHumidity &&
                      defaultIconOfPoint({
                        collect,
                        lon: Number(longitude),
                        lat: Number(latitude),
                        id: key,
                        firstText: siteName,
                        secondText: `湿度: ${atmosphericHumidity}%`,
                      });
                  });
                },
              });
              that.pointCollects.shidu = collect;
            } else {
              that.pointCollects.shidu.show = true;
            }
          },
          qiya() {
            // TODO 等待接口添加字段
            if (!that.pointCollects.hasOwnProperty("qiya")) {
              const collect = new Cesium.EntityCollection();
              this.default({
                success(res) {
                  res.forEach((item) => {
                    const { airPressure, key, latitude, longitude, siteName } =
                      item;
                    airPressure &&
                      defaultIconOfPoint({
                        collect,
                        lon: Number(longitude),
                        lat: Number(latitude),
                        id: key,
                        firstText: siteName,
                        secondText: `气压: ${airPressure}kPa`,
                      });
                  });
                },
              });
              that.pointCollects.qiya = collect;
            } else {
              that.pointCollects.qiya.show = true;
            }
          },
          fuyanglizi() {
            if (!that.pointCollects.hasOwnProperty("fuyanglizi")) {
              const collect = new Cesium.EntityCollection();
              this.default({
                success(res) {
                  res.forEach((item) => {
                    const {
                      negativeOxideIon,
                      key,
                      latitude,
                      longitude,
                      siteName,
                    } = item;
                    negativeOxideIon &&
                      defaultIconOfPoint({
                        collect,
                        lon: Number(longitude),
                        lat: Number(latitude),
                        id: key,
                        firstText: siteName,
                        secondText: `负氧离子: ${negativeOxideIon}个/cm³`,
                      });
                  });
                },
              });
              that.pointCollects.fuyanglizi = collect;
            } else {
              that.pointCollects.fuyanglizi.show = true;
            }
          },
          pm25() {
            if (!that.pointCollects.hasOwnProperty("pm25")) {
              const collect = new Cesium.EntityCollection();
              this.default({
                success(res) {
                  res.forEach((item) => {
                    const { pm25, key, latitude, longitude, siteName } = item;
                    pm25 &&
                      defaultIconOfPoint({
                        collect,
                        lon: Number(longitude),
                        lat: Number(latitude),
                        id: key,
                        firstText: siteName,
                        secondText: `PM2.5: ${pm25}μg/cm³`,
                      });
                  });
                },
              });
              that.pointCollects.pm25 = collect;
            } else {
              that.pointCollects.pm25.show = true;
            }
          },
          pm10() {
            if (!that.pointCollects.hasOwnProperty("pm10")) {
              const collect = new Cesium.EntityCollection();
              this.default({
                success(res) {
                  res.forEach((item) => {
                    const { pm10, key, latitude, longitude, siteName } = item;
                    pm10 &&
                      defaultIconOfPoint({
                        collect,
                        lon: Number(longitude),
                        lat: Number(latitude),
                        id: key,
                        firstText: siteName,
                        secondText: `PM10: ${pm10}μg/cm³`,
                      });
                  });
                },
              });
              that.pointCollects.pm10 = collect;
            } else {
              that.pointCollects.pm10.show = true;
            }
          },
        },
        shebei: {
          getData({ type }) {
            if (!that.pointCollects.hasOwnProperty(type)) {
              const collect = new Cesium.EntityCollection();
              if(type=="camera"){
                let cameraDevice = {
                  PageIndex: 1,
                  PageSize: 999,
                  EquipmentType: "Monitor",
                  DeviceId: null,
                  DeviceName: "",
                  DeviceType: "",
                  DeviceTypes: [],
                  RegionId: "",
                  IsOnline: "",
                  ScenicId: null,
                };
              //摄像头设备
                new MyApis.BaseDataApi()
                  .GetEquipmentPagingList(cameraDevice)
                  .then((r) => {
                    let data = r.data.Data;
                    let content = data.PageContents;
                    // console.log("content")
                    // console.log(content)
                    if(content&&content.length>0){
                      content.forEach((element, index) => {
                      const {
                          Latitude,
                          Longitude,
                          type: resType,
                          deviceCode,
                          DeviceId,
                          code,
                          id,
                          secondText,
                        } = element;
                        let name = element.DeviceName;
                        let status = 0;
                        if(element.IsOnline){
                          status = 1;
                        }else{
                          status = 0;
                        }
                        const icon = shebeiIcons[type][status];
                        const key = `shebei|${type}|${DeviceId}}`;
                        const point = renderPoint({
                          width: 38,
                          height: 50,
                          id: key,
                          lon: Number(Longitude),
                          lat: Number(Latitude),
                          name,
                          img: icon,
                        });
                        // console.log("point")
                        // console.log(point)
                        collect.add(point);
                      });
                    }
                    })
                    .catch((e) => {
                      // reject(e);
                      // this.$message({
                      //   type: "error",
                      //   message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                      // });
                    }); 
                }
                if(type=="broadcast"){
                  // 广播设备
                  let BroadcastParams = {
                    PageIndex: 1,
                    PageSize: 999,
                    EquipmentType: "Broadcast",
                    DeviceId: null,
                    DeviceName: null,
                    DeviceType: null,
                    DeviceTypes: [],
                    RegionId: null,
                  };
                  // const BroadcastPromise = new Promise((resolve, reject) => {
                    new MyApis.BaseDataApi()
                      .GetEquipmentPagingList(BroadcastParams)
                      .then((r) => {
                        let data = r.data.Data;
                        let content = data.PageContents;
                        // console.log("content")
                        // console.log(content)
                        if(content&&content.length>0){
                          content.forEach((element, index) => {
                          const {
                              Latitude,
                              Longitude,
                              type: resType,
                              deviceCode,
                              DeviceId,
                              code,
                              id,
                              secondText,
                            } = element;
                            let name = element.DeviceName;
                            let  status = 0
                            if(element.IsOnline){
                              status = 1;
                            }else{
                              status = 0;
                            }
                            const icon = shebeiIcons[type][status];
                            const key = `shebei|${type}|${DeviceId}}`;
                            const point = renderPoint({
                              width: 38,
                              height: 50,
                              id: key,
                              lon: Number(Longitude),
                              lat: Number(Latitude),
                              name,
                              img: icon,
                            });
                            // console.log("point")
                            // console.log(point)
                            collect.add(point);
                          });
                        }
                      })
                      .catch((e) => {
                        // reject(e);
                        // this.$message({
                        //   type: "error",
                        //   message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                        // });
                      });
                  // });
                }
                if(type=="wifi"){
                  // WiFi设备
                  let wifiParams = {
                    PageIndex: 1,
                    PageSize: 999,
                    Name: "",
                    IP: "",
                    Status: -1,
                    Location: "",
                    TotalCount: 0,
                    StartNumber: 0,
                    EndNumber: 0,
                  };
                  new MyApis.WifiApi()
                    .GetDeviceListPaging(wifiParams)
                    .then((r) => {
                      console.log("r")
                      console.log(r)
                      let data = r.data.Data;
                      let content = data.PageContents;
                      // console.log(content)
                      if(content&&content.length>0){
                        content.forEach((element, index) => {
                          if(element.Latitude==""||element.Longitude==""){
                            return
                          }
                        const {
                              Latitude,
                              Longitude,
                              type: resType,
                              Status,
                              deviceCode,
                              Id,
                              code,
                              id,
                              secondText,
                            } = element;
                            let name = element.Name+" 在线人数:"+ element.VisitorCount;
                            const icon = shebeiIcons[type][Status];
                            const key = `shebei|${type}|${Id}}`;
                            const point = renderPoint({
                              width: 38,
                              height: 50,
                              id: key,
                              lon: Number(Longitude),
                              lat: Number(Latitude),
                              name,
                              img: icon,
                            });
                            // console.log("point")
                            // console.log(point)
                            collect.add(point);
                          });
                        }
                    })
                    .catch((e) => {
                      // this.$message({
                      //   type: "error",
                      //   message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                      // });
                    });
                }
              if(type=="led"){ 
                let ledParams = {
                  page: 1,
                  size: 999,
                  type: "led",
                  entityType: "",
                  code: "",
                  belongUnitCode: "",
                  entityTypeCode: "",
                  typeOneCode: "led",
                  typeTwoCode: "",
                  name: "",
                  columnName: "id",
                  columnSortType: "desc",
                };
                // const ledPromise = new Promise((resolve, reject) => {
                  dataServerApi.resDeviceFindPage(ledParams).then((res) => {
                    //  console.log("led+res")
                    //  console.log(res)
                    if (res.code == 0) {
                      let content =res.data;
                        if(content&&content.length>0){
                          content.forEach((element, index) => {
                          const {
                                latitude,
                                longitude,
                                type: resType,
                                status,
                                name,
                                deviceCode,
                                deviceId,
                                code,
                                id,
                                secondText,
                              } = element;
                              const icon = shebeiIcons[type][status];
                              const key = `shebei|${type}|${deviceId}}`;
                              const point = renderPoint({
                                width: 38,
                                height: 50,
                                id: key,
                                lon: Number(longitude),
                                lat: Number(latitude),
                                name,
                                img: icon,
                              });
                              collect.add(point);
                            });
                          }
                    } else {
                      
                    }
                  });
              }

            if(type=="sos"){
                let sos = {
                  page: 1,
                  size: 10,
                  type: "sos",
                  entityType: "",
                  code: "",
                  belongUnitCode: "",
                  entityTypeCode: "",
                  typeOneCode: "sos",
                  typeTwoCode: "",
                  name: "",
                  columnName: "id",
                  columnSortType: "desc",
                  entityCode: "",
                  subarea: "",
                  monitorId: null,
                };
              //sos
                dataServerApi.resDeviceFindPage(sos).then((res) => {
                  //  console.log("SOS")
                  //  console.log(res)
                  if (res.code == 0) {
                    let content = res.data;
                    if(content&&content.length>0){
                          content.forEach((element, index) => {
                          const {
                              latitude,
                              longitude,
                                type: resType,
                                status,
                                name,
                                deviceCode,
                                deviceId,
                                code,
                                id,
                                secondText,
                              } = element;
                              const icon = shebeiIcons[type][status];
                              const key = `shebei|${type}|${deviceId}}`;
                              const point = renderPoint({
                                width: 38,
                                height: 50,
                                id: key,
                                lon: Number(longitude),
                                lat: Number(latitude),
                                name,
                                img: icon,
                              });
                              collect.add(point);
                            });
                          }
                  } else {
                  }
                });
              }

 
   

              // queryEquipment({
              //   success(res) {
              //     res.forEach((element, index) => {
              //       const {
              //         wgsLatitude,
              //         wgsLongitude,
              //         type: resType,
              //         status,
              //         name,
              //         deviceCode,
              //         deviceId,
              //         code,
              //         id,
              //         secondText,
              //       } = element;
              //       const icon = shebeiIcons[type][status];
              //       const key = `shebei|${type}|${deviceId}}`;
              //       console.log(key, wgsLatitude, wgsLongitude);
              //       const point = renderPoint({
              //         width: 38,
              //         height: 50,
              //         id: key,
              //         lon: Number(wgsLongitude),
              //         lat: Number(wgsLatitude),
              //         name,
              //         img: icon,
              //       });
              //       collect.add(point);
              //     });
              //   },
              //   type,
              // });
              that.pointCollects[type] = collect;
            } else {
              that.pointCollects[type].show = true;
            }
          },
          default() {
            this.camera();
            this.led();
            this.broadcast();
            this.sos();
            this.wifi();
          },
          camera() {
            this.getData({ type: "camera" });
          },
          led() {
            this.getData({ type: "led" });
          },
          broadcast() {
            this.getData({ type: "broadcast" });
          },
          sos() {
            this.getData({ type: "sos" });
          },
          wifi() {
            this.getData({ type: "wifi" });
          },
        },
        dizhi: {
          default() {
            if (!that.pointCollects.hasOwnProperty("dizhi")) {
              const collect = new Cesium.EntityCollection();
              queryGeology({
                success(res) {
                  const {
                    date,
                    hor,
                    wgsLatitude,
                    wgsLongitude,
                    name,
                    resCode,
                    ver,
                    x,
                    y,
                    z,
                  } = res;
                  geologyPoiIcon({ hor, name, ver, x, y, z }).then(
                    ({ img }) => {
                      const point = renderPoint({
                        id: "dizhi|dizhi|only",
                        lon: Number(wgsLongitude),
                        lat: Number(wgsLatitude),
                        name: "",
                        img,
                        width: 90,
                        height: 230,
                      });
                      collect.add(point);
                    }
                  );
                },
              });
              that.pointCollects.dizhi = collect;
            } else {
              that.pointCollects.dizhi.show = true;
            }
          },
        },
        xiangmu: {
          default() {},
        },
      };
      if (methods[typeFather].hasOwnProperty(type)) {
        methods[typeFather][type]();
      } else {
        methods[typeFather].default();
      }
    },
    randomString(e) {
      e = e || 32;
      var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
      for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
      return n;
    },
    mapLoaded() {
      this.changeTab(0);
    },
    handleLeftHide: function () {
      this.isLeftSideHide = !this.isLeftSideHide;
    },
    handleRightHide: function () {
      this.isRightSideHide = !this.isRightSideHide;
    },
    closeSOS: function () {
      this.isShowSoS = !this.isShowSoS;
    },
    closeFrom() {
      this.isShowSoSForm = !this.isShowSoSForm;
    },
    closeMsgDetail() {
      this.isShowMsgdP = false;
    },
    //关闭报警详情
    closeMsgWarningDetail() {
      this.isShowMsgWarning = false;
    },
    //关闭求助详情
    closeMsgHelpDetail() {
      this.isShowMsgHelp = false;
    },
    handleBottomHide: function () {
      this.isBottomHide = !this.isBottomHide;

      if (this.isBottomHide) {
        // eslint-disable-next-line no-undef
        $(".toggles.combineToggle").hide();
      } else {
        // eslint-disable-next-line no-undef
        $(".toggles.combineToggle").show();
      }
    },
    closePOP() {
      this.isShowPop = false;
    },
    closegrid() {
      this.isShowGrid = !this.isShowGrid;
    },
    closeEquipMent() {
      this.isShowEquip = !this.isShowEquip;
    },
    handleREN() {
      this.isShowEquip = !this.isShowEquip;
      this.isShowSoSForm = true;
    },
    handleTask(val) {
      // this.isShowEquip = !this.isShowEquip;
      this.messageDatail = this.messageInfo;
      this.isShowPop = true;
    },
    closeMsg() {
      this.isShowMsgWarning = false;
      this.isShowMsgHelp = false;
      this.isShowMsgdP = false;
    },
    lookMsgDetail(msg, messageInfo) {
      this.messageInfo = messageInfo;
      if (messageInfo.messageType == "early_warning") {
        this.isShowMsgWarning = true;
        this.alarmId = messageInfo.sourceId;
      } else if (messageInfo.messageType == "help") {
        this.isShowMsgHelp = true;

        this.alarmId = messageInfo.sourceId;
      } else {
        this.isShowMsgdP = true;
      }

      this.msgId = msg;
      this.isShowMsgDetail = true;
    },
    showaddTask() {
      this.isShowPop = true;
      this.messageDatail = {};
    },
    showTaskDetail(val) {
      this.isTaskD = true;
      this.ExecutTaskId = val;

      this.isLookDetails = true;
    },
    closeTaskDetail() {
      this.isTaskD = false;
    },
    mapControl({ type, value, index, state }) {
      let that = this;
      const { createRegion, removeRegion } = this;
      const mapExample = this.$refs.map;
      const {
        getCenterPosition,
        flyToPoint,
        showVector,
        hideVector,
        switchMapType,
        renderPolygon,
        removePolygon,
        renderHeatMap,
        removeHeatMap,
      } = mapExample;
      console.log({ type, value, index, state });
      const methods = {
        mapType: {
          default() {
            const currentRegion = that.region[index];
            that.regionIndex = index;
            const {
              center: { longitude: lon, latitude: lat },
            } = currentRegion;
            const { height, pitch } = getCenterPosition();
            const { heading } = that.mapInitData;
            console.log({ lon, lat, height, pitch, currentRegion, index });

            flyToPoint(lon, lat, height, heading, pitch);
            if (that.showBound) {
              createRegion();
            }
          },
        },
        map: {
          map() {
            showVector();
            switchMapType("2D");
          },
          twod() {
            hideVector();
            switchMapType("2D");
            console.log("mapControl 2d");
          },
          threed() {
            hideVector();
            switchMapType("3D");
          },
          draw() {},
        },
        marker: {
          hot() {
            if (state) {
              rateOfFlow({
                type: "midujiance",
                success(res) {
                  renderHeatMap(res);
                },
              });
            } else {
              removeHeatMap();
            }
          },
          bound() {
            that.showBound = state;
            console.log("removeRegion", state);
            if (state) {
              createRegion();
            } else {
              console.log("removeRegion");
              removeRegion();
            }
          },
        },
        grid: {
          default() {
            //切换网格类型时，先清除之前的面
            if (that.gridList.length > 0) {
              that.gridList.forEach((item) => {
                removePolygon(`grid|${item.id}`);
              });
              that.gridList = [];
            }
            //如果是网格OFF,则不显示弹窗
            if (value === "-1") {
              return;
            }

            const cesiumColor = [
              Cesium.Color.RED.withAlpha(0.5),
              Cesium.Color.GREEN.withAlpha(0.5),
              Cesium.Color.BLUE.withAlpha(0.5),
              Cesium.Color.ORANGE.withAlpha(0.5),
              Cesium.Color.AQUA.withAlpha(0.5),
              Cesium.Color.AZURE.withAlpha(0.5),
              Cesium.Color.AQUAMARINE.withAlpha(0.5),

              Cesium.Color.BLUEVIOLET.withAlpha(0.5),
              Cesium.Color.BROWN.withAlpha(0.5),
              Cesium.Color.BURLYWOOD.withAlpha(0.5),
              Cesium.Color.CADETBLUE.withAlpha(0.5),
              Cesium.Color.CHARTREUSE.withAlpha(0.5),
              Cesium.Color.CHOCOLATE.withAlpha(0.5),
              Cesium.Color.CORAL.withAlpha(0.5),
              Cesium.Color.CORNFLOWERBLUE.withAlpha(0.5),
              Cesium.Color.CORNSILK.withAlpha(0.5),
              Cesium.Color.CRIMSON.withAlpha(0.5),
              Cesium.Color.DARKBLUE.withAlpha(0.5),
              Cesium.Color.DARKCYAN.withAlpha(0.5),
              Cesium.Color.DARKGOLDENROD.withAlpha(0.5),
              Cesium.Color.DARKGREEN.withAlpha(0.5),
              Cesium.Color.DARKKHAKI.withAlpha(0.5),
              Cesium.Color.DARKMAGENTA.withAlpha(0.5),
              Cesium.Color.DARKOLIVEGREEN.withAlpha(0.5),
              Cesium.Color.DARKORANGE.withAlpha(0.5),
              Cesium.Color.DARKORCHID.withAlpha(0.5),
              Cesium.Color.DARKRED.withAlpha(0.5),
              Cesium.Color.DARKSALMON.withAlpha(0.5),
              Cesium.Color.DARKSEAGREEN.withAlpha(0.5),
              Cesium.Color.DARKSLATEBLUE.withAlpha(0.5),
              Cesium.Color.BEIGE.withAlpha(0.5),
            ];
            //查询该网格类型下的所有网格
            queryGridFindPage({
              data: { page: 1, size: 100, gridType: value },
              success(res) {
                window.polygonCenterArray = [];
                that.gridList = res;

                that.gridList.forEach((item, index) => {
                  let gridItem = item;
                  let arr = JSON.parse(gridItem.extra);
                  const start = arr[0];
                  arr.push(start);
                  const pointArray = arr
                    .join(",")
                    .split(",")
                    .map((item) => Number(item));
                  that.gridElementId = gridItem.id;

                  let pointArr = [];
                  for (let i = 0; i < pointArray.length; i = i + 2) {
                    //百度经纬度坐标转国测局坐标
                    var bd09togcj02 = coordtransform.bd09togcj02(
                      pointArray[i],
                      pointArray[i + 1]
                    );

                    // pointArr.push(bd09togcj02);
                    if (bd09togcj02 && bd09togcj02.length == 2) {
                      //国测局坐标转wgs84坐标
                      var gcj02towgs84 = coordtransform.gcj02towgs84(
                        bd09togcj02[0],
                        bd09togcj02[1]
                      );
                      if (bd09togcj02 && bd09togcj02.length == 2) {
                        pointArr.push(gcj02towgs84[0]);
                        pointArr.push(gcj02towgs84[1]);
                      }
                    }
                  }

                  renderPolygon({
                    id: `grid|${gridItem.id}`,
                    pointArray: pointArr,
                    options: {
                      lineColor: "#00ffff",
                      outlineColor: "transparent",
                      materialColor: cesiumColor[index],
                    },
                    name: gridItem.name || "",
                    showLabel: true,
                    lableOptions: {
                      offsetx: 0,
                      offsety: 0,
                    },
                  });

                  // const collect = new Cesium.EntityCollection();
                  // that.defaultIconOfPoint({
                  //   lon: 88.08284578646307,
                  //   lat: 43.969725317062874,
                  //   id: `grid|point|${gridItem.id}`,
                  //   firstText: "网格",
                  //   secondText: "网格",
                  //   collect,
                  // });
                });

                // that.gridId = gridItem.type;
                that.isShowGrid = true;
              },
            });
          },
          off() {
            removePolygon(that.gridElementId);
          },
        },
        fun: {
          center() {
            const { longitude, latitude, height, heading, pitch } =
              that.mapInitData;
            flyToPoint(longitude, latitude, height, heading, pitch);
          },
          direction() {
            const { lon, lat, height, pitch } = getCenterPosition();
            const { heading } = that.mapInitData;
            console.log(lon, lat, height, pitch);
            flyToPoint(lon, lat, height, heading, pitch);
          },
        },
      };
      if (methods[type].hasOwnProperty(value)) {
        methods[type][value]();
      } else {
        methods[type].default();
      }
    },
    getmsgalert() {
      let _this = this;
      let params = {
        second: 10,
        order: "id",
        sort: "desc",
      };
      getMsgPOP(params).then((res) => {
        if (res.code == 0) {
          let result = res.data;
          if (result.length > 0) {
            _this.earlyMsgData = res.data[0];
            _this.$store.dispatch("submittEarlyMsg", _this.earlyMsgData);
            // _this.submittEarlyMsg(result.data);
            // setTimeout(function(){
            _this.isShowEquip = true;
            _this.playAudio();
            // },1000)
            setTimeout(function () {
              _this.isShowEquip = false;
              _this.closeAudio();
            }, 3000);
          }
        }
      });
    },
    getdutyList() {
      let _this = this;
      lookduty({}).then((res) => {
        _this.dutyList = res.data;
      });
    },

    multiarr(arr) {
      let count = 1;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] instanceof Array) {
          count++;
          arr = arr[i];
          this.multiarr(arr);
        }
      }
      return count;
    },
  },
  created() {
    // console.debug("mapview created");
    const that = this;
    this.getdutyList();
    // 组件创建时，设置本页样式
    // eslint-disable-next-line no-undef
    $(".zj-app").addClass("zj-fullscreen-mapview");
    this.$on("poiselected", this.onSearchResultPoiSelected);
    queryBounds({
      success(res) {
        const arr = res.map((item, index) => {
          let extra = item.extra;
          item.bounds = [];
          const bounds = JSON.parse(extra);
          let arrCount = that.multiarr(bounds);
          if (arrCount == 3) {
            bounds.forEach((element) => {
              if (Array.isArray(element)) {
                element.push(element[0]);
                const [longitude, latitude] = centerOfMass(
                  heleprs.polygon([element])
                ).geometry.coordinates;
                item.bounds.push({
                  bound: element,
                  center: { longitude, latitude },
                });
              }
            });
            const [longitude, latitude] = centerOfMass(heleprs.polygon(bounds))
              .geometry.coordinates;
            item.center = { longitude, latitude };
          } else if (arrCount == 1) {
            const pointArray = bounds
              .join(",")
              .split(",")
              .map((item) => Number(item));
            var tmpBounds = [];
            for (let i = 0, j = 0; i < pointArray.length; i = i + 2) {
              tmpBounds[j] = [pointArray[i], pointArray[i + 1]];
              j++;
            }
            [tmpBounds].forEach((element) => {
              if (Array.isArray(element)) {
                element.push(element[0]);
                const [longitude, latitude] = centerOfMass(
                  heleprs.polygon([element])
                ).geometry.coordinates;
                item.bounds.push({
                  bound: element,
                  center: { longitude, latitude },
                });
              }
            });
            const [longitude, latitude] = centerOfMass(
              heleprs.polygon([tmpBounds])
            ).geometry.coordinates;
            item.center = { longitude, latitude };
          }

          return item;
        });
        that.region = arr;
      },
    });

    //  this.ws = websoket.initWebsoket();
    //   // console.log('this.ws')
    //   // console.log(this.ws)
    //   this.ws.onopen = this.onOpen();
    //   this.ws.onmessage = this.onMessage();
    // this.ws.onerror = this.onError();
    // this.ws.onclose = this.onClose();
  },
  mounted() {
    let _this = this;
    // eslint-disable-next-line no-undef
    $(".zj-app").addClass("zj-fullscreen-mapview");
    this.$on("poiselected", this.onSearchResultPoiSelected);
    // this.$refs.map.initLocation({
    //   longitude: 88.127965771,
    //   latitude: 43.885640247
    //   // })
    const that = this;
    // eslint-disable-next-line no-undef
    $(".zj-app").addClass("zj-fullscreen-mapview");
    this.$on("poiselected", this.onSearchResultPoiSelected);
    let form = new FormData();
    form.append("page", 1);
    form.append("size", 10);
    form.append("groupcode", "gridType");
    queryGridType(form)
      .then((res) => {
        if (res.data) {
          const arr = [{ name: "网格OFF", type: "off", code: "-1" }].concat(
            res.data.map((item) => {
              item.type = item.id;
              item.name = item.value;
              return item;
            })
          );
          that.gridTypeList = arr;
        }
      })
      .catch((e) => {
        console.log(e);
      });

    this.$refs.map.initLocation(this.mapInitData);
  },
  // updated(){

  // },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
    if(this.tongxunTimer){
      clearInterval(this.tongxunTimer);
    }
  },
  destroyed() {
    // 销毁组件时，还原样式
    // eslint-disable-next-line no-undef
    $(".zj-app").removeClass("zj-fullscreen-mapview");
  },
};
</script>
<style lang="scss" scoped>
.tabBox {
  width: 460px;
  height: 36px;
  position: fixed;
  left: 50%;
  top: 13%;
  margin-left: -230px;
  z-index: 10000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(15, 36, 69, 0.8);
  border: solid 1px #2bc2ff;
  padding: 0px 25px;
  box-sizing: border-box;
  li {
    list-style: none;
    padding: 0px 12px;
    height: 100%;
    line-height: 36px;
    font-size: 16px;
    cursor: pointer;
  }
  .activeLi {
    background-image: linear-gradient(
      0deg,
      rgba(11, 58, 119, 0.7) 0%,
      rgba(12, 51, 100, 0.2) 64%,
      rgba(12, 47, 89, 0.1) 100%
    );
    border-bottom: 2px solid #00c6ff;
    color: #2ac1ff;
  }
}
.left-side-flow {
  width: 19%;
  height: 79%;
  // height: 74%;
  min-width: 320px;
  background-color: rgba(15, 36, 69, 0.8);
  border: solid 1px #2bc2ff;
  position: absolute;
  left: 2%;
  top: 116px;
  z-index: 10000;
  overflow: auto;
  /* 火狐滚动条 */
  scrollbar-width: none;
}
/*定义滚动条的整体样式使其变窄*/
.left-side-flow::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  display: none;
}
.left-side-flow2::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  display: none;
}
.left-side-flow2 {
  width: 19%;
  height: 34%;
  min-width: 320px;
  background-color: rgba(15, 36, 69, 0.8);
  border: solid 1px #2bc2ff;
  position: absolute;
  left: 2%;
  top: 116px;
  z-index: 10000;
  overflow: auto;
}
.right-side_box {
  width: 19%;
  height: 79%;
  min-width: 320px;
  background-color: rgba(15, 36, 69, 0.8);
  border: solid 1px #2bc2ff;
  z-index: 10000;
  overflow: hidden;
  padding: 26px 15px 15px;
  box-sizing: border-box;
}
.right-side_box2 {
  width: 19%;
  height: 79%;
  min-width: 320px;
  background-color: rgba(15, 36, 69, 0.8);
  border: solid 1px #2bc2ff;
  z-index: 10000;
  overflow: hidden;
  padding: 26px 0px 15px;
  box-sizing: border-box;
}
.positionR1 {
  position: absolute;
  right: 242px;
  top: 116px;
}
.positionR2 {
  position: absolute;
  right: 66px;
  top: 116px;
}

.positionR3 {
  position: absolute;
  right: 578px;
  top: 116px;
}
#transform_box {
  transform: translate(-100000px);
}
</style>